export const PHONE_TEL = "tel:0894853994";
export const PHONE_DISPLAY = "089 485 3994";
export const EMAIL = "easyskip.admin@gmail.com";
export const EMAIL_MAILTO = "mailto:easyskip.admin@gmail.com";

export const BTN_PRIMARY =
  "inline-flex items-center justify-center gap-2 rounded-full bg-ink px-7 py-3.5 font-heading text-sm font-bold text-white transition-colors duration-300 hover:bg-emerald-800";

export const BTN_GHOST =
  "inline-flex items-center justify-center gap-2 rounded-full border border-ink/20 px-7 py-3.5 font-heading text-sm font-bold text-ink transition-colors duration-300 hover:bg-ink hover:text-white";

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/prices", label: "Prices" },
  { to: "/reviews", label: "Reviews" },
  { to: "/contact", label: "Contact" },
];

export const SKIPS = [
  {
    id: "4yd",
    name: "4 Cubic Yard",
    tag: "Midi Skip",
    price: 250,
    priceLabel: "€250",
    bags: "40–45 black bags",
    note: "Perfect for kitchen refits, bulky waste and room clear-outs",
    popular: true,
    img: "/images/skip-4cy.png",
  },
  {
    id: "6yd",
    name: "6 Cubic Yard",
    tag: "Standard Builder Skip",
    price: 400,
    priceLabel: "€400",
    bags: "60–65 black bags",
    note: "Takes heavy rubble, soil, concrete and full house clearances",
    popular: false,
    img: "/images/skip-6cy.png",
  },
  {
    id: "8yd",
    name: "8 Cubic Yard",
    tag: "Large Skip",
    price: null,
    priceLabel: "Enquiry only",
    bags: "80–85 black bags",
    note: "Big clear-outs and light construction waste — send an enquiry for a price",
    popular: false,
    img: "/images/skip-8cy.png",
  },
  {
    id: "14yd",
    name: "14 Cubic Yard",
    tag: "Extra Large Skip",
    price: null,
    priceLabel: "Enquiry only",
    bags: "140+ black bags",
    note: "Major renovations and full property clearances — send an enquiry for a price",
    popular: false,
    img: "/images/skip-14cy.png",
  },
  {
    id: "25ro",
    name: "25 Roll-on",
    tag: "Roll-on Roll-off",
    price: null,
    priceLabel: "Enquiry only",
    bags: "220+ black bags",
    note: "Ongoing commercial and industrial work — send an enquiry for a price",
    popular: false,
    img: "/images/skip-25roro.png",
  },
  {
    id: "40ro",
    name: "40 Roll-on",
    tag: "Roll-on Roll-off",
    price: null,
    priceLabel: "Enquiry only",
    bags: "350+ black bags",
    note: "Maximum capacity for major sites and demolitions — send an enquiry for a price",
    popular: false,
    img: "/images/skip-40roro.png",
  },
];

export const REVIEWS = [
  {
    name: "Siobhán Murphy",
    location: "Dublin 8",
    rating: 5,
    text: "Booked the 6-yard for our house renovation on a Tuesday morning and it was outside the door by lunch. Collection was just as quick. Couldn't fault them.",
  },
  {
    name: "Declan O'Brien",
    location: "Naas, Kildare",
    rating: 5,
    text: "We run three sites and Easyskip handle all of them. Prices are straight, drivers are sound, and they actually answer the phone. Rare enough these days.",
  },
  {
    name: "Aoife Kelly",
    location: "Tallaght, Dublin",
    rating: 5,
    text: "The 4-yard midi was perfect for our kitchen refit and €250 all-in was the best quote I got. They even sorted the road permit for me.",
  },
  {
    name: "Patrick Connolly",
    location: "Celbridge, Kildare",
    rating: 5,
    text: "Heavy rubble job, needed a builders skip fast. Delivered same day, placed exactly where I asked, no damage to the drive. Proper outfit.",
  },
  {
    name: "Niamh Walsh",
    location: "Ranelagh, Dublin",
    rating: 4,
    text: "Garden clear-out done and dusted. Only small delay on collection day but they kept me posted the whole time. Would use again.",
  },
  {
    name: "Brendan Hayes",
    location: "Maynooth, Kildare",
    rating: 5,
    text: "Full house clearance between tenants. The 5-day hire meant no panic, and knowing nearly all of it gets recycled matters to me.",
  },
];

export const FAQS = [
  {
    q: "Do I need a permit for my skip?",
    a: "On your own driveway or private land, no permit is needed. On a public road the council requires one — mention it when booking and we'll arrange it.",
  },
  {
    q: "What is the weight limit?",
    a: "Every skip includes a 3-tonne weight limit. For heavy waste like soil or rubble, the 6 cubic yard builder skip is the right choice.",
  },
  {
    q: "How long can I keep the skip?",
    a: "5 days hire is included as standard. Need longer? Call 089 485 3994 and we'll extend it for a small daily fee.",
  },
  {
    q: "What can't go in the skip?",
    a: "No asbestos, tyres, batteries, paint, fridges, freezers, gas cylinders or hazardous waste. Wood, metal, soil, rubble, furniture and general household waste are all fine.",
  },
  {
    q: "How do I pay?",
    a: "Online by card when you book — secure checkout via Stripe. €250 for the 4 cubic yard, €400 for the 6 cubic yard, no hidden fees.",
  },
];

export const IMAGES = {
  hero: "/images/hero-truck.png",
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const SERVICE_AREA_KEYS = new Set([
  "D01", "D02", "D03", "D04", "D05", "D06", "D07", "D08", "D09", "D10",
  "D11", "D12", "D13", "D14", "D15", "D16", "D17", "D18", "D20", "D22", "D24", "D6W",
  "K32", "K34", "K36", "K45", "K56", "K67", "K78", "A41", "A42", "A45", "A94", "A96",
  "R14", "R51", "R56", "W12", "W23", "W34", "W91",
]);
